import React, { useEffect, useRef, useState } from "react";
import SectionMagazineCategories from "components/Sections/SectionMagazineCategories"
import { useParams } from "react-router-dom"
import { Slide } from 'react-slideshow-image';
import horoskop from "../../../images/horoskop.jpg"
import 'react-slideshow-image/dist/styles.css'
import HeaderFilter from "components/Sections/HeaderFilter"

const PageHoroskop = () => {
  const [data,setData] = useState([])
  const initialized = useRef(false);


  const spanStyle = {
    padding: '20px',
    background: "none",
    color: 'white',
    fontSize:"50px"
  }
  
  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    height: '250px'
  }

  const slideImages = [
    // {
    //   url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    //   caption: "Horoskop"
    // },
    // {
    //   url:"https://i.ibb.co/LttdKXB/pexels-sharefaith-491036-1202723.jpg",
    //   caption: "Horoskop"
    // },
    {
      url: horoskop,
      caption: "Horoskop"
    },
  ]; 

  return (
    <div className={`nc-PageArchiveAudio `}>
      {/* HEADER */}
      <div className="w-full px-2 xl:max-w-screen-2xl mx-auto">
        <div className="container" style={{marginTop:"37px", textAlign:"left"}}>
          <HeaderFilter heading="Horoskop"/>
        {/* <Slide>
         {slideImages.map((slideImage, index)=> (
            <div className="container" key={index}>
              <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
              </div>
            </div>
          ))} 
        </Slide> */}
          {/* <div className="absolute inset-0 text-white flex flex-col items-center justify-center">
            <h2 style={{fontSize:"50px"}} className="inline-block align-middle ml-3">
              Horoskop
            </h2>
          </div> */}
        </div>
      </div>
      {/* ====================== END HEADER ====================== */}

      <div className="container lg:pb-28 space-y-16 lg:space-y-28">
        <div>
          {/* <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="block my-4 border-b w-full border-neutral-300 dark:border-neutral-500 sm:hidden"></div>
          </div> */}
              <h2>Lipiec 2025</h2>
            <div className="horoskop-container">
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Baran 21 marca do 19 kwietnia
                </h4>
                <p>
                Jeśli masz listę rzeczy do zrobienia w najbliższych tygodniach, zniszcz ją. Przed tobą tyle zwrotów akcji, ile przeszkód. W tej sytuacji zwykłe postępy nie będą możliwe. Każda realizacja będzie oznaczać rezygnację z jednej rzeczy, by zyskać inną. Wyczerpujące, ale jeśli potraktujesz to jak grę, nauczysz się zasad i może nawet lepiej na tym wyjdziesz.
            </p>
            </div>
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Byk 20 kwietnia do 22 maja
                </h4>
                <p>
                Zawsze warto dokonać wyboru, gdy jest dostępnych kilka opcji, a nie czekać, aż los pozostawi cię z jedną. Uran popycha cię do zrobienia śmiałego kroku w przyszłość, a twoją pierwszą reakcją jest jak zwykle odmowa. Jednak planety i tak wymuszą na tobie zmiany, więc podejmij decyzję teraz, kiedy masz jeszcze kontrolę nad tym, co się dzieje.
            </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Bliźnięta 23 maja do 21 czerwca
                </h4>
                <p>
                W tym miesiącu Uran wchodzi do twojego znaku, przynosząc niepokój i pragnienie zmian. Ale podsuwa też milion nowych pomysłów. I to ci się podoba. Ale nie myśl, że musisz działać w odniesieniu do wszystkich naraz. Zastanów się, zanim ślepo w coś się rzucisz.
            </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Rak 22 czerwca do 22 lipca
                </h4>
                <p>
                Nowe, potężne wpływy Saturna i Neptuna w twojej karierze. Czy to oznacza, że niedawna zmiana pracy była błędem? Nie. Ugruntowanie pozycji w obecnej roli przypomina parkowanie auta w ciasnym miejscu – musisz kilka razy podjechać do przodu i do tyłu, zanim idealnie się ustawisz. I to jest to, co teraz robisz.
              </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Lew 23 lipca do 23 sierpnia
                </h4>
                <p>
                W co naprawdę wierzysz? Co jest dla ciebie ważne? Mówisz rzeczy, z którymi się nie zgadzasz, by awansować? Ten miesiąc dotyczy twojej filozofii – jest taka sama jak zawsze czy ostatnie wydarzenia skłoniły cię do wprowadzenia zmian? Wkrótce możesz się dowiedzieć, ile kosztuje utrzymanie i obrona tych zasad. Czy cię na to stać?
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Panna 24 sierpnia do 22 września
                </h4>
                <p>
                Czyż to nie miło, gdy okazuje się, że miałaś rację? Nie próbowałaś niczego udowadniać, pracowałaś jak zawsze, a potem okazało się, że twoje pomysły były świetne i teraz wszyscy cię chwalą. Może nawet dostaniesz awans. Próbujesz ignorować całą tę uwagę, ale w końcu zmieniasz zdanie i pozwalasz sobie na pięć minut sławy. Ciesz się tym!
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Waga 23 września do 22 października
                </h4>
                <p>
                Wygląda na to, że coś, co straciłaś nadzieję kiedykolwiek osiągnąć, pojawi się w twoim zasięgu. Może myślałaś, że nigdy nie dostaniesz takiej szansy, na szczęście to nieprawda. Jest za wcześnie, żeby wiedzieć, jak sytuacja się rozwinie, ale spróbuj, póki możesz. To wprowadzi cię na znacznie szczęśliwszą drogę.
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Skorpion 23 października do 21 listopada
                </h4>
                <p>
                Dwa projekty, w które jesteś w pełni zaangażowana i w których chcesz odnieść sukces, ciągną cię w różnych kierunkach. W takich sytuacjach łatwo zostać bez niczego. Musisz zdecydować, który z nich ma priorytet, a od którego jesteś gotowa zrobić mały krok w tył. To będzie najlepsze rozwiązanie.
                </p>
            </div>       
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Strzelec 22 listopada do 21 grudnia
                </h4>
                <p>
                Kreatywna wyobraźnia to coś, z czym nie masz problemu, a nawet masz jej za dużo. Możesz wyobrazić sobie setki różnych przyszłości dla siebie. Twoim zadaniem na kilka najbliższych tygodni jest ujarzmienie tej kreatywności. Wybierz jedną ze swoich wizji i zrealizuj ją, zapominając o reszcie.
                </p>
            </div>        
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Koziorożec 22 grudnia do 19 stycznia
                </h4>
                <p>
                Po śmiałym nowym początku wydaje ci się, że stoisz teraz w miejscu i zastanawiasz się, czy nie powinnaś jednak zawrócić. Nie. Zostań tam, gdzie jesteś. To długoterminowy projekt, więc powinnaś dać sobie dużo czasu. Bliższa współpraca z kolegą przyniesie korzyści wam obojgu.
                </p>
            </div>        
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Wodnik 20 stycznia do 18 lutego
                </h4>
                <p>
                Nadchodzące tygodnie będą miały łagodniejszy charakter. Nadal masz rzeczy do zrobienia, ale też wystarczająco dużo czasu, by je wykonać. Wielkie zmiany z ostatnich miesięcy wydają się mieć mniejszy wpływ, niż myślałaś. Czujesz się zrelaksowana i szczęśliwa, a twoje życie osobiste jest spokojniejsze i słodsze.
            </p>
            </div>
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Ryby 19 lutego do 20 marca
                </h4>
                <p>
                Wszyscy spod znaku Ryb znają horror próby ucieczki z miejsca, w którym nie chcą być, tylko po to, by odkryć, że drzwi wyjściowe są zamknięte. Możesz teraz czuć się podobnie, ale nie martw się, gdy się zbliżysz, drzwi się otworzą. A tak naprawdę możesz ich nie potrzebować, sama świadomość, że masz możliwość ucieczki, sprawi, że poczujesz się lepiej.
            </p>
            </div>                  
            </div>

          {/* <SectionMagazineCategories
            category={params.category}
            category_id={params.id}
            posts={data}
          /> */}

        </div>

        {/* <div className="relative py-16">
          <BackgroundSection />
        </div> */}
      </div>
    </div>
  );
};

export default PageHoroskop
